export default __webpack_public_path__ + "static/media/45.252cfa32.jpg";